import Image from "next/image";
import HeaderComponent from "../components/Header";
import NavigationComponent from "../components/HeaderNavigation";
import FooterComponent from "../components/Footer";
import { useState, useEffect } from "react";
import {
  MdOutlineKeyboardArrowUp,
  MdOutlineKeyboardArrowDown,
} from "react-icons/md";

export default function Home() {
  const [loginState, setLoginState] = useState(false);
  const checkLogIn = async () => {
    const l = await checkLoggedIn();
    setLoginState(l);
  };

  const [faq, setFaq] = useState(200);

  const faqs = [
    {
      title: "Title 1",
      content: "Content 1",
    },
    {
      title: "Title 2",
      content: "Content 2",
    },
    {
      title: "Title 3",
      content: "Content 3",
    },
    {
      title: "Title 4",
      content: "Content 4",
    },
  ];

  useEffect(function () {
    checkLogIn();
  }, []);

  return (
    <div>
      <HeaderComponent loggedinState={loginState} />
      <hr />
      <NavigationComponent /> {/* Impractical jokers */}
      <hr />
      <div className={`font-bold text-l md:text-left text-[40px] mt-2 mx-4`}>
        Frequently Asked Questions
      </div>
      <div
        className={`md:h-screen flex flex-col md:flex-row justify-between gap-x-10 w-full px-4 my-10 py-8`}
      >
        <div
          className={`h-[100%] w-[100%] xl:h-[500px] xl:w-[500px] 2xl:h-[600px] 2xl:w-[600px] md:block my-auto`}
        >
          <Image
            src={"/images/FAQs-amico 1.png"}
            layout={"intrinsic"}
            alt='none'
            width={800}
            height={800}
            className="w-[100%] h-[100%]"
          />
          <div className={`text-center`}>OR</div>
          <div className={`text-center`}>bartcashsupport@gmail.com</div>
        </div>
        <div
          className={`mx-auto py-4 flex flex-col text-center justify-center w-11/12 md:w-6/12 xl:w-4/12`}
        >
          <div className={`text-l md:text-left text-[16px] my-4`}>
            Want to contact us, submit your questions here and we will get back
            to you as soon as possible
          </div>

          <div className="accordion py-10" id="accordionExample">
            {faqs.map((faquestion, index) => {
              return (
                <div key={index} className="accordion-item bg-white">
                  <h2 className="accordion-header mb-0" id="headingOne">
                    <button
                      className={`
                      ${faq == index ? "" : "collapsed"}
                      relative
                      flex
                      justify-between
                      items-center
                      w-full
                      my-4
                      rounded-[20px]
                      py-2
                      px-4
                      text-base text-gray-800 text-left
                      bg-white
                      transition
                      focus:outline-none
                      border
                      border-light-gray
                      shadow-md
                      `}
                      onClick={() => {
                        setFaq(index);
                      }}
                      type="button"
                    >
                      <div>{faquestion.title}</div>
                      <div>
                        {faq == index ? (
                          <MdOutlineKeyboardArrowUp />
                        ) : (
                          <MdOutlineKeyboardArrowDown />
                        )}
                      </div>
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className={`${
                      faq == index ? "show" : "collapse accordion-collapse"
                    }`}
                  >
                    <div
                      className={`accordion-body py-4 px-5 rounded-br-[10px] rounded-bl-[10px] shadow-md border`}
                    >
                      {faquestion.content}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <button
            className={`p-2 px-8 text-white bg-primary text-sm rounded-[10px] w-fit mx-auto mb-4`}
          >
            Submit
          </button>
        </div>
      </div>
      <FooterComponent />
    </div>
  );
}
